/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.entities.detail.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.permissions',
  'acme.common.factory.gridState',
  'acme.view.application.entities.detail.availability.controllers'
])

.controller('EntitiesDetailController', ['$scope', '$state', 'ApiService', 'HelpersService', 'PermissionsService', 'GridStateFactory', function($scope, $state, ApiService, HelpersService, PermissionsService, GridStateFactory) {


  $scope.entitiesDetail = {

    entity: {},
    model: {},
    resource: {
      name: '',
      department: '',
      image: '',
      email: '',
      phoneNumber: ''
    },
    sections: {
      profile: {
        open: true
      },
      criteria: {
        open: true
      },
      available: {
        open: true
      }
    },
    assignments: [],
    selectionCriteria: [],

    ownerGridState: new GridStateFactory(),

    init: function() {

      if ($state.params && $state.params.id && $state.params.type) {
        var self = this;
        self.initData();
        self.getInstances($state.params.id);
        self.entity = HelpersService.getEntityName($state.params.type);

        if (!PermissionsService.check('ENTITY_' + self.entity.singular.toUpperCase() + '_VIEW')) {
          console.log('ENTITY_' + self.entity.singular.toUpperCase() + '_VIEW');
          $state.go('home.default', {}, { notify: true });
        }

        $scope.$emit('Application::contentTitleChange', {
          title: HelpersService.cap(self.entity.plural)
        });

        $scope.$emit('AppController::updateTitle', {
          title: HelpersService.cap(self.entity.plural)
        });
      }
    },

    initData: function() {
      this.initEntity()
        .then(this.success.initData, this.error.initData);
    },

    initEntity: function() {
      return ApiService.entity.detail({
        id: $state.params.id,
        type: $state.params.type
      });
    },

    getAssignPermissions: function() {
      return 'ENTITY_' + this.entity.singular.toUpperCase() + '_ASSIGN';
    },

    getSchedulePermissions: function() {
      return 'ENTITY_' + this.entity.singular.toUpperCase() + '_SCHEDULE_VIEW';
    },

    getInstances: function(id) {
      this.ownerGridState.setPropertyValue('pageSize', '-1');
      this.ownerGridState.setPropertyValue('sortField', 'name');
      this.ownerGridState.setPropertyValue('sortDirection', 'asc');

      ApiService.resource.instances.ownerList($.extend({}, { ownerId: id }, this.ownerGridState.getGridState())).then(this.success.getInstances, this.error.getInstances);
    },

    getAssignments: function() {
      var i, ii,
          r = [];
      for (i=0,ii=this.assignments.length;i<ii;i++) {
        r.push(this.assignments[i].resourceTemplateName);
      }
      return r.join(', ');
    },

    getSkillLabel: function() {

      var r = {
        plural: '',
        pluralCap: '',
        singular: '',
        singularCap: ''
      };

      if (this.entity.plural === 'personnel') {
        r.plural = 'roles';
        r.pluralCap = 'Roles';
        r.singular = 'role';
        r.singularCap = 'Role';
      }else{
        r.plural = 'types';
        r.pluralCap = 'Types';
        r.singular = 'type';
        r.singularCap = 'Type';
      }

      return r;

    },

    getProfileDetails: function() {
      var uuid = '',
          title = this.model.name;

      switch(this.entity.plural) {
        case 'facilities':
          uuid = '5afa7c3a-e2ea-4d73-8d53-0e0788a84076';

          this.resource.name = this.model.name;
          this.resource.department = this.model.department;
          this.resource.email = '';
          this.resource.phoneNumber = '';

          break;
        case 'equipment':
          uuid = '21583c37-a424-4f27-b3b6-fdc3bdb437bc';

          this.resource.name = this.model.name;
          this.resource.department = this.model.department;
          this.resource.email = '';
          this.resource.phoneNumber = '';

          break;
        case 'personnel':
          uuid = this.model.profileImage || '09728cd8-2be9-4966-8ca3-7cfe0ef9e5c9';
          title = this.model.firstName + ' ' + this.model.lastName;

          this.resource.name = this.model.firstName + ' ' + this.model.lastName;
          this.resource.department = this.model.department;
          this.resource.email = this.model.email;
          this.resource.phoneNumber = this.model.phoneNumber;

          break;
      }

      $scope.$emit('Application::contentTitleChange', {
        title: title,
        buttonLeft: {
          label: 'Back',
          action: function () {
            window.history.go(-1);
          }
        },
        buttonRight: {
          label: 'Edit',
          action: function () {
            $state.go('application.entities.edit', { type: $state.params.type, id: $state.params.id });
          }
        }
      });

      this.resource.image = '/v1/api/photos/' + uuid + '/PM';

    },

    openSection: function(name) {
      this.sections[name].open = true;
    },

    closeSection: function(name) {
      this.sections[name].open = false;
    },

    toggleSection: function(name) {
      this.sections[name].open = !this.sections[name].open;
    },

    isSectionOpen: function(name) {
      return (this.sections[name].open);
    },

    addSelectionCriteria: function() {
      this.selectionCriteria.push({});
    },

    removeSelectionCriteria: function(index) {
      this.selectionCriteria.splice(index, 1);
    },

    isEntityType: function(type) {
      return (this.entity.singular === type);
    },


    success: {

      initEntity: function(response) {
        $scope.entitiesDetail.model = response.data.payload;
        $scope.entitiesDetail.getProfileDetails();
      },

      initData: function(response) {
        $scope.entitiesDetail.success.initEntity(response);
      },

      getInstances: function(response) {
        $scope.entitiesDetail.assignments = response.data.payload.list;
      }
    },

    error: {
      initEntity: function(response) {},
      initData: function(response) {},
      getInstances: function(response) {}
    }
  };

  $scope.entitiesDetail.init();

}]);